import React from 'react';
import './Plan.css'; // Import your CSS file

import { Button } from '../../components';



const Plan = ({ plan }) => {

  const { title, icon, content, image, price, unit, features } = plan;

  return (
    <div className="plan-item">

      <img src={image} alt={title} /> {/* Plan Image */}

      <div className='plan-content'>
        <div className='icon-container'>
          <div className='top-icon'>{icon}</div> {/* Plan Icon */}
        </div>
        <div className='top'>
          <h3>{title}</h3> {/* Plan Title */}
          <h5>{content}</h5> {/* Plan Description */}
        </div>
        <div className='content'>
          {/* List of Features */}
          <ul>
            {features.map((feature, index) => (
              <li key={index}>{feature}</li> 
            ))}
          </ul>
          <div className='price-box'>
            <div className='price'>${price}</div> {/* Plan Price */}
            <p>/ {unit}</p>
          </div>
          <Button link={"Get-Quote"} title={"Get Started"} />
        </div>
      </div>

    </div>
  );
};

export default Plan;